import {
  completeInviteRequest,
  completeOnboardingRequest,
  InviteApiError,
  InviteApiErrorDetails,
  VerifyInviteResponse,
  verifyInviteRequest
} from "./inviteAPI";

export { InviteApiError };
export type { InviteApiErrorDetails, VerifyInviteResponse };

const REQUIRED_TOKEN_ERROR =
  "This invitation link is invalid.";

const REQUIRED_PASSWORD_ERROR = "Password is required to continue.";

export const verifyInviteLink = async (
  token: string
): Promise<VerifyInviteResponse> => {
  const trimmedToken = token?.trim();
  if (!trimmedToken) {
    throw new InviteApiError(REQUIRED_TOKEN_ERROR, 400);
  }
  return verifyInviteRequest(trimmedToken);
};

export const completeInvite = async (input: {
  redeemToken: string;
  password: string;
}) => {
  const redeemToken = input.redeemToken?.trim();
  if (!redeemToken) {
    throw new InviteApiError(REQUIRED_TOKEN_ERROR, 400);
  }

  const password = input.password?.trim();
  if (!password) {
    throw new InviteApiError(REQUIRED_PASSWORD_ERROR, 400);
  }

  return completeInviteRequest({
    redeemToken,
    password
  });
};

export const completeOnboarding = () => completeOnboardingRequest();
